import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Table, Card } from "antd";
import { req_list_pim_review_all } from "../../api";
import { formateDateDbT } from "../../utils/dateUtil";
class ReviewHistoryLogModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  state = {
    loading: false,
    lock: false,
    data: [],
    setStaffCode: "",
    setClockDate: "",
  };

  componentDidMount() {
    this.api_item_list();
  } 

  api_item_list = async () => {
    const { ReviewType, CaseKey } = this.props.data;
    const { token } = this.props.user;
    console.log(this.props.data);
    this.setState({ loading: true });
    const result = await req_list_pim_review_all(ReviewType, CaseKey, token);
    if (result.total > 0) {
      const items = result.data;
     // console.log(items);
      this.setState({
        data: items,
        loading: false,
      });
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  render() {
    const { data, loading } = this.state;
    const columns = [
      {
        title: "人員",
        dataIndex: "OperatorCode",
        key: "OperatorCode",
      },
      {
        title: "時間",
        dataIndex: "RecordCreateDatetime",
        key: "RecordCreateDatetime",
        render: (text) => <>{formateDateDbT(text)}</>,
      },
      {
        title: "說明",
        dataIndex: "OperatorDescription",
        key: "OperatorDescription",
      },
    ];
    return (
      <Card>
        <h3>歷程紀錄</h3>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
          scroll={{
            y: 55 * 5,
          }}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ReviewHistoryLogModal);
